<template>
  <b-col>
    <h1 class="color-brand-4 tw-text-24px tw-font-medium">Acces cont Fabrica de asigurari</h1>

    <b-btn variant="link" @click="prevStep">< Pasul anterior</b-btn>

    <div v-if="login_register_show">
      <b-row class="mx-1">
        <span class="text-success">{{ forgot_password_message }}</span>
      </b-row>
      <b-row class="mx-1 mb-3">
        <label class="mb-1 tw-text-primary-gray">E-mail</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text bg-white"><i class="fa fa-envelope text-primary bg-white"></i></span>
          </div>
          <input id="email" type="email" class="form-control tw-h-12" placeholder="nume@email.com" required
                 :class="status($v.email_login)" v-model="email_login">
        </div>
      </b-row>
      <b-row class="mx-1">
        <b-row class="justify-content-between w-100 mx-1">
          <label class="mb-1 tw-text-primary-gray">Parola</label>
          <small class="text-muted"><a class="text-primary" style="cursor: pointer" @click="login_register_show = false">Ai uitat parola?</a></small>
        </b-row>
        <div class="input-group" id="show_hide_password">
          <div class="input-group-prepend">
            <span class="input-group-text bg-white"><i class="fa fa-lock text-primary bg-white"></i></span>
          </div>
          <input type="password" class="form-control tw-h-12" placeholder="*********" required
                 :class="status($v.password)" v-model="password">
          <div class="input-group-append">
            <span class="input-group-text bg-white"><a href="#" @click="showPass"><i class="fa fa-eye-slash" aria-hidden="true"></i></a></span>
          </div>
        </div>
        <span class="text-danger">{{ error_login }}</span>
      </b-row>

      <b-row>
        <b-btn variant="primary" class="py-2 px-4 ml-3 mt-3 mb-4 btn btn-primary bg-brand-1 hover-bg-brand-4" @click="login">Continuă</b-btn>
      </b-row>

      <b-row class="mx-1 mt-3 justify-content-center">
        <p>Sau</p>
      </b-row>

      <b-row class="mx-1">
        <label class="mb-1 tw-text-primary-gray">E-mail</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text bg-white"><i class="fa fa-envelope text-primary bg-white"></i></span>
          </div>
          <input type="text" class="form-control tw-h-12" placeholder="nume@email.com" required
                 :class="status($v.email)" v-model="email">
        </div>
        <span class="text-danger">{{ error_register }}</span>
      </b-row>

      <b-row class="mx-1">
        <p><span class="fa fa-info-circle"></span> Contul va fi creat cu adresa ta de e-mail,
          iar parola va fi generată automat. După activarea contului prin link-ul primit pe email, iți vei putea schimba
          parola.</p>
      </b-row>

      <b-row class="pb-3">
        <b-btn variant="primary" class="btn tw-border-1 border-brand-4 color-brand-4 hover-bg-brand-4 hover:tw-text-white ml-3 mt-3 mb-3" @click="register">Creează cont nou</b-btn>
      </b-row>

      <form :action="orderData.payment_url" ref="paymentForm" method="POST" id="payment_form">
        <input type="hidden" name="env_key" :value="orderData.env_key"/>
        <input type="hidden" name="data" :value="orderData.data"/>
      </form>
    </div>
    <div v-if="!login_register_show">
      <b-row class="mx-1">
        <label class="mb-1 tw-text-primary-gray">E-mail</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text bg-white"><i class="fa fa-envelope text-primary bg-white"></i></span>
          </div>
          <input type="text" class="form-control tw-h-12" placeholder="nume@email.com" required
                 :class="status($v.forgot_password_email)" v-model="forgot_password_email">
        </div>
        <span class="text-danger">{{ forgot_password_error }}</span>
      </b-row>
      <b-row>
        <b-btn variant="primary" class="py-2 px-4 ml-3 mt-3 btn btn-primary border-brand-4 color-brand-4 hover-bg-brand-4 hover:tw-text-white tw-h-12 w-50" @click="forgot_password">{{isMobile ? 'RECUPEREAZĂ' : 'RECUPEREAZĂ PAROLA'}}</b-btn>
      </b-row>
      <b-row class="pb-3">
        <b-btn variant="primary" class="py-2 px-4 ml-3 mt-3 btn btn-primary bg-brand-1 hover-bg-brand-4 tw-h-12 w-50" @click="login_register_show = true">Intră în cont</b-btn>
      </b-row>
    </div>

    <!-- <CollectorData :collector="collector"></CollectorData> -->
  </b-col>

</template>

<script>
import {validationMixin} from 'vuelidate';
import {required, requiredIf} from 'vuelidate/lib/validators';
import {email} from '../validations';
import {
  FORGOT_PASSWORD,
  IS_LOGGED_IN, LOGIN,
  ORDER, REGISTER,
  SAVE_TRAVELERS, SET_SAVE_DATA
} from "../store/travel.module";
import {mapGetters} from "vuex";
import EventBus from '../eventbus';
import CollectorData from "./CollectorData";

export default {
  name: "TravelAuth",
  metaInfo: {
    title: 'Autentificare - Asigurare calatorie online - Fabrica de Asigurari',
  },
  data() {
    return {
      email: '',
      email_login: '',
      password: '',
      error_register: '',
      error_login: '',

      forgot_password_email: '',
      forgot_password_message: '',
      forgot_password_error: '',

      login_clicked: false,
      login_register_show: true
    }
  },
  created() {
    //Hide side panel for the login specific one
    document.getElementById('travel-login-loaded').classList.remove('d-md-block');
    document.getElementById('travel-login-panel').classList.remove('d-none');

    document.getElementById('travel-login-panel').classList.remove('col-md-4');
    document.getElementById('travel-login-panel').classList.add('col-md-6');

    document.getElementById('form-panel').classList.remove('col-md-8');
    document.getElementById('form-panel').classList.add('col-md-6');
  },
  mixins: [validationMixin],
  validations() {
    return {
      email: {
        required: requiredIf(() => {
          return !this.login_clicked && this.login_register_show;
        }),
        email: email
      },
      email_login: {
        required: requiredIf(() => {
          return this.login_clicked && this.login_register_show;
        }),
        email: email
      },
      forgot_password_email: {
        required: requiredIf(() => {
          return !this.login_register_show;
        }),
        email: email
      },
      password: {
        required: requiredIf(() => {
          return this.login_clicked && this.login_register_show;
        })
      },
    }
  },
  mounted() {
    this.$router.push('/asigurare-de-calatorie/autentificare');
    $('#email').focus();
  },
  computed: {
    ...mapGetters(['travelers', 'orderData', 'collector']),
    saveData: {
      get () {
        return this.$store.getters.saveData
      },
      set (value) {
        this.$store.commit(SET_SAVE_DATA, value)
      }
    },
    isMobile() {
      return window.screen.width < 575.98;
    }
  },
  methods: {
    prevStep() {
      EventBus.$emit('prev-step');
    },
    status(validation) {
      if (!validation) return {};
      return {
        error: validation.$error,
        dirty: validation.$dirty
      }
    },
    showPass() {
      event.preventDefault();
      if($('#show_hide_password input').attr("type") == "text"){
        $('#show_hide_password input').attr('type', 'password');
        $('#show_hide_password i').addClass( "fa-eye-slash" );
        $('#show_hide_password i').removeClass( "fa-eye" );
      }else if($('#show_hide_password input').attr("type") == "password"){
        $('#show_hide_password input').attr('type', 'text');
        $('#show_hide_password i').removeClass( "fa-eye-slash" );
        $('#show_hide_password i').addClass( "fa-eye" );
      }
    },
    register() {
      this.login_clicked = false;

      this.$v.$touch()
      if (this.$v.$anyError) return;

      this.$store.dispatch(REGISTER, this.email)
          .then(() => {
            let promises = [this.$store.dispatch(ORDER, {travelers: this.travelers})];
            if (this.saveData) promises.push(this.$store.dispatch(SAVE_TRAVELERS, this.travelers));
            Promise.all(promises)
                .then(() => {
                  this.$refs.paymentForm.submit();
                })
                .catch(err => console.log(err));
          })
          .catch(err => {
            this.error_register = err;
            if (this.error_register === 'Already exists') this.error_register = "Exista deja un cont cu acest email";
            console.log(err)
          });
    },
    login() {
      this.login_clicked = true;

      this.$v.$touch()
      if (this.$v.$anyError) return;

      this.$store.dispatch(LOGIN, {email : this.email_login, password : this.password})
          .then(() => {
            let promises = [this.$store.dispatch(ORDER, {travelers: this.travelers})];
            if (this.saveData) promises.push(this.$store.dispatch(SAVE_TRAVELERS, this.travelers));
            Promise.all(promises)
                .then(() => {
                  this.$refs.paymentForm.submit();
                })
                .catch(err => console.log(err));
          })
          .catch(err => {
            this.error_login = err;
            console.log(err)
          });
    },
    forgot_password() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      this.$store.dispatch(FORGOT_PASSWORD, {email: this.forgot_password_email})
        .then((res) => {
          this.forgot_password_message = res.data.message;
          this.$v.$reset();
          this.login_register_show = true;
        })
        .catch(err => {
          this.forgot_password_error = err;
          console.log(err);
        });
    }
  },
  components: {CollectorData}
}
</script>

<style scoped>
.card-body {
  padding: 0;
}

.error {
  border-color: red;
  /*background: #FDD;*/
}

.error:focus {
  outline-color: #F99;
}
</style>
